import { EAppEnvironment } from '../../util/constants';
import { parseEnvironment } from '../../util/helpers';

export enum ELaunchDarklyEnvId {
    development = '5eb1fc7d5cc8fd0a5b5477fe',
    staging = '5eb3111d9bd20a0a7016f434',
    sandbox = '5f205c1c6c73040adf4d0b22',
    production = '5e4d809297f3cb0802551d85',
}

export const getLaunchDarklyEnvId = (): ELaunchDarklyEnvId => {
    const environment = parseEnvironment(window.location.origin);
    switch (environment) {
        case EAppEnvironment.devLocal:
            return ELaunchDarklyEnvId.development;
        case EAppEnvironment.local:
            return ELaunchDarklyEnvId.development;
        case EAppEnvironment.ngrok:
            return ELaunchDarklyEnvId.development;
        case EAppEnvironment.staging:
            return ELaunchDarklyEnvId.staging;
        case EAppEnvironment.devSandbox:
            return ELaunchDarklyEnvId.sandbox;
        case EAppEnvironment.production:
            return ELaunchDarklyEnvId.production;
        default:
            return ELaunchDarklyEnvId.production;
    }
};
